module.exports = __webpack_public_path__ + "img/gb-eng.87dd4b83.png";